'use client';

import { Typography } from '@/components/ui/Text';
import { useCallback } from 'react';
import { useWizardNavigation } from '../../hooks/useWizardNavigation';
import { IntakePageTextBox } from '../common/IntakePageTextBox';
import { IntakeStepWrapper } from '../common/IntakeStepWrapper';

export const WelcomeStep = () => {
  const { goToNextStep, goToPreviousStep, hasPreviousStep } =
    useWizardNavigation();

  const handleSubmit = useCallback(
    (event: React.FormEvent) => {
      event.preventDefault();

      goToNextStep();
    },
    [goToNextStep]
  );

  return (
    <IntakeStepWrapper
      heading='Get your personalized quote in minutes.'
      description='Once you have your quote, you can unlock immediate access to Sollis.'
      onSubmit={handleSubmit}
      onBack={goToPreviousStep}
      showBack={hasPreviousStep}
    >
      <IntakePageTextBox variant='cream'>
        <Typography variant='body-small'>
          Signature memberships start at $4,000 annually (as little as $11/day).
          Final prices vary based on age, membership tier, and location.
        </Typography>
      </IntakePageTextBox>
    </IntakeStepWrapper>
  );
};
